import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const base = `${u}/topics`;

export const getAllTopics = () =>
  apiFetch(base).then(r => r.ok ? r.json() : Promise.reject(r));

export const getTopicLabels = () =>
  apiFetch(`${base}/labels`).then(r => r.ok ? r.json() : Promise.reject(r));

export const getTopic = (id) =>
  apiFetch(`${base}/${id}`).then(r => r.ok ? r.json() : Promise.reject(r));

export const createTopic = (data) =>
  apiFetch(base, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const regenerateTopic = (id) =>
  apiFetch(`${base}/${id}/regenerate`, { method: "POST" })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const updateTopic = (id, data) =>
  apiFetch(`${base}/${id}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
    .then(r => r.ok ? r.json() : Promise.reject(r));

export const deleteTopic = (id) =>
  apiFetch(`${base}/${id}`, { method: "DELETE" });
